import styled from "styled-components";

export const Container = styled.nav`
    width: 100%;
    height: 72px;

    @media(min-width:768px) {
        height: 100%;
        width: auto;
    }
`

export const NavitemsList = styled.ul`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 0 40px;
    height: 100%;

    @media(min-width:768px) {
        display: flex;
        padding: 0;
    }
    
`